<template>
  <div class="projects">

    <header-bar></header-bar>

    <section class="background-image">
      <div class="grid-container">
        <div class="col-6">
          <h2>Big Ideas Map - Coming soon!</h2>
          <p>Share and promote, connect with and contribute to projects and initiatives on the ground in Africa – exchange ideas, and drive change for Africa</p>
        </div>
      </div>
    </section>


  </div>
</template>

<script>
import mailchimp from 'mailchimp-v3'

import HeaderBar from '@/components/HeaderBar'

export default {
  data () {
    return {
      mailchimp: mailchimp
    }
  },
  components: {
    HeaderBar
  },
  methods: {
    testMailchimp () {
      mailchimp.setApiKey('d6a20355664643f51fa850ed860f42c7-us15')
      mailchimp
        .get('lists')
        .then(function (lists) {
          console.log(lists)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Projects.vue?453ecf85